import axios from "axios";
import { message as AntdAlert } from "antd";
import { put, takeLatest } from "redux-saga/effects";
import * as actions from "../actions";
import * as constants from "../constants";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";

export function* handleFetchTeacherAssign({ data }) {
  try {
    const response = yield axios.get(`${baseURL}/api/v2/admin/badges`);
    const { success } = response.data;
    if (success) {
      yield put(actions.fetchTeacherAssignSuccess(response.data.data.badges));
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchTeacherAssignError());
    AntdAlert.error("Something wentwent wrong!");
    console.log(error);
  }
}

export function* handleUpdateTeacherAssign(action) {
  const { payload } = action;

  const { _id, category_id, name, deleted_status, badges } = payload;

  try {
    const fd = new FormData();
    fd.append("category_id", category_id);
    fd.append("name", name);
    fd.append("deleted_status", deleted_status);
    fd.append("badges", badges);

    const response = yield axios.put(
      `${baseURL}/api/v2/admin/badges/${_id}`,
      fd
    );

    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateTeacherAssignSuccess(response.data.data.badge));
    } else {
      console.error("Teacher assign update failed:", message);
      AntdAlert.error(message);
      yield put(actions.updateTeacherAssignError(response.data.data));
      errorHandler(response.data);
    }
  } catch (error) {
    console.error("API request error:", error);
    yield put(
      actions.updateTeacherAssignError(error?.response?.data?.data || {})
    );
    AntdAlert.error("Something went wrong!");
  }
}

export function* handleCreateTeacherAssign({ data }) {
  const { category_id, name, deleted_status, badges } = data;
  try {
    const fd = new FormData();
    fd.append("category_id", category_id);
    fd.append("name", name);
    fd.append("deleted_status", deleted_status);
    fd.append("badges", badges);
    const response = yield axios.post(`${baseURL}/api/v2/admin/badges`, fd);
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.createTeacherAssignSuccess(response.data.data.badge));
    } else if (!success) {
      AntdAlert.error(response.data?.errors[0]);
      yield put(actions.createTeacherAssignError(data.id));
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
    yield put(actions.createTeacherAssignError());
  }
}

export function* watcherTeacherAssignSaga() {
  yield takeLatest(constants.FETCH_TEACHER_ASSIGN, handleFetchTeacherAssign);
  yield takeLatest(constants.CREATE_TEACHER_ASSIGN, handleCreateTeacherAssign);
  yield takeLatest(constants.UPDATE_TEACHER_ASSIGN, handleUpdateTeacherAssign);
}
